import { action, observable } from 'mobx'
import { GenericStore } from './AdminStore'

export default class AchievementStore extends GenericStore {
  @observable statistics = null
  @observable rewardOptions = {
    cinemas: [],
    movies: [],
  }

  async fetchData(match) {
    const response = await super.fetchData(match)
    this.setStatistics(response.data.statistics || null)
    this.setRewardOptions(response.data.reward_options || null)
    return response
  }

  @action setStatistics(statistics) {
    this.statistics = statistics
  }

  @action setRewardOptions(rewardOptions) {
    this.rewardOptions = rewardOptions || {
      cinemas: [],
      movies: [],
    }
  }

  @action clearItems() {
    super.clearItems()
    this.statistics = null
    this.setRewardOptions(null)
  }
}
